import styled from 'styled-components';
import Button from '../button/Button';
import Typography from '../typography/Typography';
export const UnavailableButton = styled(Button) `
  margin-top: 3.2rem;
`;
export const UnavailableDescription = styled(Typography) `
  margin-top: 0.8rem;
`;
export const UnavailableContainer = styled(Typography) `
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 2.4rem 2.4rem;
  max-width: 50rem;
  ${({ theme }) => theme.media.laptopM `
    padding:0 3.6rem 3.6rem;
  `}
`;
export const UnavailableImage = styled.img `
  margin-bottom: 2.4rem;
  ${({ theme }) => theme.media.laptopM `
    margin-bottom:3.6rem;
  `}
`;
//# sourceMappingURL=style.js.map